var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversationalframeworks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.352,
    height: 161.338,
    viewBox: "0 0 161.352 161.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONVERSATIONAL_FRAMEWORKS",
    "data-name": "CONVERSATIONAL FRAMEWORKS",
    transform: "translate(-0.998 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19729",
    "data-name": "Path 19729",
    d: "M35,33h5.2V48.613H35Z",
    transform: "translate(54.48 51.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19730",
    "data-name": "Path 19730",
    d: "M27,37h5.2v5.2H27Z",
    transform: "translate(41.662 57.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19731",
    "data-name": "Path 19731",
    d: "M153.237,97.118a18.2,18.2,0,0,0-24.063,5.392L110.3,93.069v-22.8l28.838-14.422a12.884,12.884,0,0,0,6.828,4.562,13.009,13.009,0,1,0-9.2-15.933,12.863,12.863,0,0,0,.047,6.716L110.3,64.447V47.84H84.275V37.223a18.216,18.216,0,1,0-5.2,0V47.84H53.049v16.6L26.537,51.189A12.967,12.967,0,0,0,10.648,35.274a13.01,13.01,0,1,0,13.56,20.571l28.84,14.419v22.8L34.169,102.5a18.184,18.184,0,1,0,2.334,4.65l16.545-8.267V115.5H79.071v21.081a13.011,13.011,0,1,0,5.2,0V115.5H110.3V98.888l16.54,8.27a18.217,18.217,0,1,0,26.4-10.039ZM21.819,117.4a5.2,5.2,0,1,1,1.9-7.109,5.2,5.2,0,0,1-1.9,7.109ZM76.469,19.216a5.2,5.2,0,1,1,5.2,5.2A5.2,5.2,0,0,1,76.469,19.216ZM63.458,58.249h5.2v5.2h-5.2Zm36.431,46.84H63.458V89.476H73.866v-5.2H84.275v-5.2H99.889Zm0-31.227H63.458v-5.2H99.889Zm0-10.409H73.866v-5.2H99.889ZM148.636,115.5a5.2,5.2,0,1,1-1.9-7.109A5.2,5.2,0,0,1,148.636,115.5Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19732",
    "data-name": "Path 19732",
    d: "M31,35h5.2V45.409H31Z",
    transform: "translate(48.071 54.476)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationalframeworks);
export default __webpack_public_path__ + "static/media/CONVERSATIONAL FRAMEWORKS.b4fb79d22597e886a7e4cf0589b610b6.svg";
export { ForwardRef as ReactComponent };